import React from "react";
import { motion } from "framer-motion";
import { Quote, Briefcase } from "lucide-react";
import { Reveal, SectionHeading } from "./primitives";
import { TESTIMONIALS } from "@/data/site";

export function Testimonials() {
  return (
    <section className="relative overflow-hidden bg-ink-1 py-28" data-testid="success-stories">
      <div className="absolute inset-0 bg-grid opacity-15" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          overline="Success Stories"
          title={<>REAL STUDENTS. <span className="text-gradient">REAL OUTCOMES.</span></>}
          subtitle="Aspirants who found their college — and their career — through the A3 network."
        />
        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 3) * 0.08}>
              <motion.div whileHover={{ y: -5 }} className="flex h-full flex-col justify-between rounded-3xl border border-white/10 bg-ink-2 p-7 transition-colors duration-300 hover:border-brand-cyan/40" data-testid="testimonial-card">
                <div>
                  <Quote className="h-6 w-6 text-brand-cyan/50" />
                  <p className="mt-4 text-sm leading-relaxed text-white/70">"{t.quote}"</p>
                </div>
                <div className="mt-7">
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-brand-cyan/30 bg-brand-cyan/10 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-brand-cyan">
                    <Briefcase className="h-3 w-3" /> {t.placed}
                  </span>
                  <div className="mt-4 flex items-center gap-3">
                    <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full border border-white/15 object-cover" loading="lazy" />
                    <div>
                      <p className="font-display text-sm font-semibold text-white">{t.name}</p>
                      <p className="font-mono text-[10px] uppercase tracking-wider text-white/40">{t.program}</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
